export const DEFAULT_NAVIGATION_AUTHORIZED_VENDOR = '/vendor/home-page'
export const DEFAULT_NAVIGATION_AUTHORIZED_INTERNAL = '/internal/dashboard'
export const DEFAULT_NAVIGATION_UNAUTHORIZED = '/auth/login'
export const DEFAULT_FALLBACK_AUTH_SECRET_KEY = 'qa4xp8fXR0ZmMGxmIAbqMC1jF6O17PisWCyXIQhEqAs'
export const AUTH_PATHS = ["/auth/login", "/auth/register", "/auth/forgot-password", "/auth/change-password", "/auth/activation", "/auth/reset-password"];
export const ALLOWED_PUBLIC_PATHS = [...AUTH_PATHS, "/user-guide/", "/faq"];
